// extracted by mini-css-extract-plugin
export var label = "_i9-2";
export var slideContainer = "_i9-0";
export var slider = "_i9-1";